module.exports = __webpack_public_path__ + "img/gala-games-only-logo.dd94432.svg";